module.exports = __webpack_public_path__ + "static/media/avenger.4bafa358.png";